/**
 * shareParam  传感器国际化
 * date：2022 04 19
 */
 export default {
    sensor:{
        temp:'温度',
        hum:'湿度',
        volt:'电压',
        rssi:'RSSI',
        lqi:'LQI',
        gas: '气体',
        magnetism: '门磁',
    }
}